import { cableRouterFor } from "@/lib/cable-router/active-router";
import { useFlag } from "@/lib/feature-flags";

export function useCableRouter() {
  return cableRouterFor(useFlag("orthogonalCableRouter"));
}
